const FLASH_SYMBOL_BOUNDS = {
  68: {
    x: -1.0,
    y: -9.2,
    width: 15.1,
    height: 40.5,
  },
};

export function displayBounds(layout, symbolData, objectName = null) {
  if (!layout) {
    return layout;
  }

  const scaleX = layout.width && symbolData?.layout?.imageWidth ? layout.width / symbolData.layout.imageWidth : 1;
  const scaleY = layout.height && symbolData?.layout?.imageHeight ? layout.height / symbolData.layout.imageHeight : 1;
  const flashBounds = objectName === "levelAim" ? FLASH_SYMBOL_BOUNDS[68] : FLASH_SYMBOL_BOUNDS[symbolData?.symbolId];
  if (flashBounds) {
    return {
      x: layout.x + flashBounds.x * scaleX,
      y: layout.y + flashBounds.y * scaleY,
      width: flashBounds.width * scaleX,
      height: flashBounds.height * scaleY,
    };
  }

  if (!symbolData?.layout) {
    return layout;
  }

  return {
    x: layout.x + symbolData.layout.imageOffsetX * scaleX,
    y: layout.y + symbolData.layout.imageOffsetY * scaleY,
    width: symbolData.layout.imageWidth * scaleX,
    height: symbolData.layout.imageHeight * scaleY,
  };
}
